"use client";
import React from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { analytics } from "lib/segment";

interface OnClickTrackersProps {
  className?: string;
  segmentMsg: string;
  segmentOpt: Record<string, any>;
  children: React.ReactNode;
}

export const OnClickTrackers = ({
  className,
  segmentMsg,
  segmentOpt,
  children,
}: OnClickTrackersProps) => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const handleOnClick = () => {
    const baseUrl = `${window.location.protocol}//${window.location.host}`;
    const currentPath = pathname || window.location.pathname;
    const queryString = searchParams.toString();
    const fullPath = queryString
      ? `${currentPath}?${queryString}`
      : currentPath;

    analytics.track(segmentMsg, {
      ...segmentOpt,
      url: fullPath,
      page_base_url: baseUrl,
      page_full_url: baseUrl + fullPath,
    });
  };

  return (
    <div onClick={handleOnClick} className={className}>
      {children}
    </div>
  );
};
